
const validators = {
  BR: {
    regex: /^\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2}$/,
    validate: (value) => {
      if (typeof value !== 'string') {
        return false
      }

      if (!validators.BR.regex.test(value)) {
        return false
      }

      return true
    }
  },
  CL: {
    regex: /[A-Za-z]/g,
    validate: (value) => {
      if (typeof value !== 'string') {
        return false
      }

      if (validators.CL.regex.test(value.replace(/[kK]/g, ''))) {
        return false
      }

      const rut = value.replace(/\./g, '').replace(/-/g, '')

      let digits = parseInt(rut.slice(0, -1), 10)
      let m = 0
      let s = 1

      while (digits > 0) {
        s = (s + digits % 10 * (9 - m++ % 6)) % 11
        digits = Math.floor(digits / 10)
      }

      return (((s > 0) ? String((s - 1)) : 'K') === rut.slice(-1))
    }
  },
  MX: {
    regex: /^([A-Z&Ñ]{3}[0-9]{6}[0-9A-Z]{3})$/,
    validate: (value) => {
      // check type
      if (typeof value !== 'string') {
        return false
      }

      // check length
      if (value.length !== 12) {
        return false
      }

      // check regex
      if (!validators.MX.regex.test(value)) {
        return false
      }

      // check format based into date
      const rfc = value.substring(3, 9)
      const year = parseInt(rfc.substring(0, 2), 10)
      const month = parseInt(rfc.substring(2, 4), 10)
      const day = parseInt(rfc.substring(4, 6), 10)
      const date = new Date(year + 2000, month - 1, day)

      if (!date) {
        return false
      }

      // check digit
      const _alphabet = '0123456789ABCDEFGHIJKLMN&OPQRSTUVWXYZ Ñ'
      const chars = '   ' + value
      const digit = chars.substring((chars.length - 2) - 11, (chars.length - 2) + 1)

      let sum = 0

      for (let i = 0; i < digit.length; i++) {
        const character = digit.charAt(i)
        const index = _alphabet.indexOf(character)
        sum += index * (13 - i)
      }

      if (parseInt(value.slice(-1)) !== parseInt(_alphabet[(11 - (sum % 11)) % 11])) {
        return false
      }

      return true
    }
  }
}

export const validateTaxId = (country, value) => {
  const validator = validators[country]
  return validator.validate(value)
}

export default {
  validators,
  validateTaxId
}
